import { ArrowDownTrayIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useInstallPrompt } from '@/contexts/InstallPromptContext';

function IOSShareIcon({ className }: { className?: string }) {
    return (
        <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 3v12M12 3l4 4M12 3 8 7" />
            <path d="M4 14v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
        </svg>
    );
}

export function InstallPromptBanner() {
    const { canInstall, isIOS, promptInstall, dismiss } = useInstallPrompt();

    if (!canInstall) return null;

    return (
        <div className="mx-4 mt-2 rounded-lg border border-blue-200 bg-blue-50 p-3 dark:border-blue-800 dark:bg-blue-900/20 md:mx-6 lg:mx-8">
            <div className="flex items-start gap-3">
                <ArrowDownTrayIcon className="mt-0.5 h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400" />
                <div className="flex-1 text-sm text-blue-700 dark:text-blue-300">
                    {isIOS ? (
                        <div>
                            <p>Install NetFiscus for quick access:</p>
                            <p className="mt-1">
                                Tap <strong>Share</strong>{' '}
                                <IOSShareIcon className="inline h-4 w-4 align-text-bottom" />{' '}
                                then <strong>"Add to Home Screen"</strong>
                            </p>
                        </div>
                    ) : (
                        <div className="flex items-center justify-between gap-3">
                            <p>Install NetFiscus for quick access.</p>
                            <button
                                onClick={promptInstall}
                                className="shrink-0 rounded-md bg-blue-600 px-3 py-1 text-xs font-medium text-white hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
                            >
                                Install
                            </button>
                        </div>
                    )}
                </div>
                <button
                    onClick={dismiss}
                    className="shrink-0 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                    aria-label="Dismiss install prompt"
                >
                    <XMarkIcon className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
}
